<template>
  <v-dialog v-model="dialog" scrollable max-width="600">
    <v-card>
      <v-card-title>
        {{ humanPowerTitle }}編集
        <v-spacer />
        <IconButton icon="mdi-close" @click="cancel" />
      </v-card-title>

      <v-card-text>
        <v-form ref="act_form">
          <v-container>
            <v-row>
              <v-col cols="6" class="pa-0">
                <v-select
                  label="表示順"
                  v-model="groupSelect"
                  item-text="label"
                  item-value="value"
                  :items="groupSelects"
                  return-object
                />
              </v-col>
              <v-col cols="12" class="pa-0">
                <v-select
                  label="行動要素"
                  v-model="actionElement"
                  item-text="label"
                  item-value="value"
                  :items="actionElements"
                  return-object
                />
              </v-col>
              <v-col cols="12" class="pt-0 pb-0 pl-1 pr-0">行動内容1 </v-col>
              <v-col cols="12" class="pa-0">
                <quillEditor
                  ref="myQuillEditor1"
                  v-model="actEmtContent1"
                  :options="editorOption"
                />
              </v-col>
              <v-col cols="6" class="pt-5 pb-0 pl-0 pr-0">
                <FormInputComponent
                  label="ウェイト1"
                  type="number"
                  v-model="actEmtWeight1"
                />
              </v-col>
              <v-col cols="12" class="pt-0 pb-0 pl-1 pr-0">行動内容2</v-col>
              <v-col cols="12" class="pa-0">
                <quillEditor
                  ref="myQuillEditor2"
                  v-model="actEmtContent2"
                  :options="editorOption"
                />
              </v-col>
              <v-col cols="6" class="pt-5 pb-0 pl-0 pr-0">
                <FormInputComponent
                  label="ウェイト2"
                  type="number"
                  v-model="actEmtWeight2"
                />
              </v-col>
              <v-col v-if="actEmtContent2" class="pt-5 pb-0 pl-3 pr-0">
                <Button
                  v-if="isDeleteBtn"
                  @click="delete_content2_confirm"
                  color="info"
                  >行動内容2削除</Button
                >
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <Button @click="erntry_confirm" color="primary">登録</Button>
              </v-col>
              <v-col>
                <Button
                  v-if="isDeleteBtn"
                  @click="delete_confirm"
                  color="danger"
                  >行動要素 削除</Button
                >
              </v-col>
            </v-row>
          </v-container>
        </v-form>
        <ConfirmDialog
          ref="confirm"
          :title="humanPowerTitleMsg"
          :message="confirmMessage"
          buttonMessage="OK"
          @confirm="editEvaluationInfo"
        >
        </ConfirmDialog>
        <DialogMessage ref="dialog" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { quillEditor } from 'vue-quill-editor';
import ConfirmDialog from '@/components/Common/ConfirmMessage.vue';
import axios from 'axios';
import config from '../../../const.js';
import message from '../../../message.js';
import moment from 'moment';
import { getSessionStorageItem } from '../../../common.js';

export default {
  components: {
    quillEditor,
    ConfirmDialog,
  },
  data: () => ({
    dialog: false,
    editData: {},
    resolve: null,
    reject: null,
    deleteFlg: false,
    deleteContent2Flg: false,
    groupId: 0,
    confirmMessage: null,
    goalId: '',
    gradeId: '',
    actEmtId: '',
    actEmtName: '',
    actEmtContent1: '',
    actEmtContent2: '',
    actEmtWeight1: '',
    actEmtWeight2: '',
    actionElement: { value: '', label: '' },
    updateFlg: true,
    isDeleteBtn: false,

    editorOption: {
      theme: 'snow',
      modules: {
        toolbar: [
          { color: ['red', 'blue', 'deeppink'] },
          'bold',
          'underline',
          'clean',
        ],
      },
      placeholder: '行動内容を入力してください。',
    },

    groupSelect: { value: '', label: '' },
    groupSelects: [
      { value: 1, label: config.GOAL_NO_STR + '1' },
      { value: 2, label: config.GOAL_NO_STR + '2' },
      { value: 3, label: config.GOAL_NO_STR + '3' },
      { value: 4, label: config.GOAL_NO_STR + '4' },
      { value: 5, label: config.GOAL_NO_STR + '5' },
      { value: 6, label: config.GOAL_NO_STR + '6' },
    ],

    actionElements: [],

    humanPowerTitle: '',
    humanPowerTitleMsg: '',

    // 目標情報
    actEmt1Id: '',
    actEmt1Name: '',
    actEmt1Content1: '',
    actEmt1Content2: '',
    actEmt1Weight1: 0,
    actEmt1Weight2: 0,
    actEmt2Id: '',
    actEmt2Name: '',
    actEmt2Content1: '',
    actEmt2Content2: '',
    actEmt2Weight1: 0,
    actEmt2Weight2: 0,
    actEmt3Id: '',
    actEmt3Name: '',
    actEmt3Content1: '',
    actEmt3Content2: '',
    actEmt3Weight1: 0,
    actEmt3Weight2: 0,
    actEmt4Id: '',
    actEmt4Name: '',
    actEmt4Content1: '',
    actEmt4Content2: '',
    actEmt4Weight1: 0,
    actEmt4Weight2: 0,
    actEmt5Id: '',
    actEmt5Name: '',
    actEmt5Content1: '',
    actEmt5Content2: '',
    actEmt5Weight1: 0,
    actEmt5Weight2: 0,
    actEmt6Id: '',
    actEmt6Name: '',
    actEmt6Content1: '',
    actEmt6Content2: '',
    actEmt6Weight1: 0,
    actEmt6Weight2: 0,
  }),
  methods: {
    open(
      goalId,
      gradeId,
      groupId,
      actEmtId,
      actEmtName,
      actEmtContent1,
      actEmtContent2,
      actEmtWeight1,
      actEmtWeight2,
      updateFlg,
      humanPowerTitle
    ) {
      // 初期化
      this.goalId = goalId;
      this.gradeId = gradeId;
      this.actionElement = { label: '', value: '' };
      this.groupSelect = { label: '', value: '' };
      this.dialog = true;
      this.updateFlg = updateFlg;

      this.humanPowerTitle = humanPowerTitle;
      this.humanPowerTitleMsg = humanPowerTitle + config.MESSAGE_EDIT;

      this.groupId = groupId;
      this.actEmtId = actEmtId;
      this.actEmtName = actEmtName;

      if (updateFlg) {
        this.isDeleteBtn = true;
      } else {
        this.isDeleteBtn = false;
      }

      if (actEmtContent1 == config.GOAL_EMPTY_STRING) {
        this.actEmtContent1 = '';
      } else {
        this.actEmtContent1 = actEmtContent1;
      }
      if (actEmtContent2 == config.GOAL_EMPTY_STRING) {
        this.actEmtContent2 = '';
      } else {
        this.actEmtContent2 = actEmtContent2;
      }

      this.actEmtWeight1 = actEmtWeight1;
      this.actEmtWeight2 = actEmtWeight2;

      this.actionElement.value = actEmtId;
      this.actionElement.label = actEmtName;

      this.groupSelect.value = groupId;
      this.groupSelect.label = config.GOAL_NO_STR + String(groupId);

      // 行動要素取得
      this.getActionElement();

      // 評価情報取得
      //this.getEvaluationItem();

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    erntry_confirm() {
      // 入力チェック
      if (!this.$refs.act_form.validate()) {
        return;
      }
      // 行動要素選択
      if (!this.actionElement.value) {
        this.$refs.dialog.open(
          'info',
          '行動要素が選択されていません。行動要素を選択して下さい。'
        );
        return;
      }
      // 行動内容１(必須)
      if (!this.actEmtContent1) {
        this.$refs.dialog.open(
          'info',
          '行動内容1が入力されていません。行動内容1を入力して下さい。'
        );
        return;
      }
      // 行動内容１(文字数)
      if (this.actEmtContent1.length > config.ACT_EMT_CONTENT_MAX_LENGTH) {
        this.$refs.dialog.open(
          'info',
          '行動内容1の文字数が多いです。入力文字数を4行程度に短くしてください。'
        );
        return;
      }
      // 行動内容２(入力されていた場合の文字数)
      if (this.actEmtContent2) {
        if (this.actEmtContent1.length > config.ACT_EMT_CONTENT_MAX_LENGTH) {
          this.$refs.dialog.open(
            'info',
            '行動内容2の文字数が多いです。入力文字数を4行程度に短くしてください。'
          );
          return;
        }
      }
      this.deleteFlg = false;
      // 確認ダイアログ表示
      this.confirmMessage = this.humanPowerTitle + '情報を登録しますか？';
      this.$refs.confirm.open();
    },
    delete_content2_confirm() {
      this.deleteFlg = true;
      this.deleteContent2Flg = true;
      // 確認ダイアログ表示
      this.confirmMessage =
        this.humanPowerTitle +
        '情報の行動内容2を削除します。よろしいですか？\n' +
        '※行動内容1は行動要素削除ボタンで削除します。';
      this.$refs.confirm.open();
    },
    delete_confirm() {
      // 入力チェック
      if (!this.$refs.act_form.validate()) {
        return;
      }
      this.deleteFlg = true;
      this.deleteContent2Flg = false;
      // 確認ダイアログ表示
      this.confirmMessage =
        this.humanPowerTitle +
        '情報を行動要素ごと削除します。よろしいですか？\n' +
        '※本処理で行動内容1と行動内容2の情報を削除します。';
      this.$refs.confirm.open();
    },
    editEvaluationInfo() {
      // セッションチェック
      let userInfo = getSessionStorageItem();
      if (userInfo == null) {
        this.$refs.dialog.open(
          'error',
          message.MSG_ERROR_SESSION + message.MSG_ERROR_SESSION_DETAIL
        );
        this.loading = false;
        return;
      }
      if (!this.deleteFlg) {
        // 登録処理
        if (this.updateFlg) {
          // 更新
          this.makeUpdateGoalInfo();
        } else {
          // 新規
          this.makeInsertGoalInfo();
        }
        this.editEvaluationInfoRequest();
      } else {
        // 削除処理
        if (this.deleteContent2Flg) {
          // 行動内容2削除
          this.makeDeleteGoalContent2();
        } else {
          // 行動要素削除
          this.makeDeleteEvaluationInfo();
        }
        this.deleteEvaluationInfoRequest();
      }
    },
    editEvaluationInfoRequest() {
      // ローディング画像表示
      this.loading = true;
      // ユーザ情報の取得
      let userInfo = getSessionStorageItem();

      // 行動内容２が入力されていない場合はEMPTY
      if (!this.actEmt1Content2) {
        this.actEmt1Content2 = config.GOAL_EMPTY_STRING;
      }
      if (!this.actEmt2Content2) {
        this.actEmt2Content2 = config.GOAL_EMPTY_STRING;
      }
      if (!this.actEmt3Content2) {
        this.actEmt3Content2 = config.GOAL_EMPTY_STRING;
      }
      if (!this.actEmt4Content2) {
        this.actEmt4Content2 = config.GOAL_EMPTY_STRING;
      }
      if (!this.actEmt5Content2) {
        this.actEmt5Content2 = config.GOAL_EMPTY_STRING;
      }
      if (!this.actEmt6Content2) {
        this.actEmt6Content2 = config.GOAL_EMPTY_STRING;
      }

      // ウェイトの整形(入力されていない場合は0を設定)
      if (!this.actEmt1Weight1) {
        this.actEmt1Weight1 = '0';
      }
      if (!this.actEmt1Weight2) {
        this.actEmt1Weight2 = '0';
      }
      if (!this.actEmt2Weight1) {
        this.actEmt2Weight1 = '0';
      }
      if (!this.actEmt2Weight2) {
        this.actEmt2Weight2 = '0';
      }
      if (!this.actEmt3Weight1) {
        this.actEmt3Weight1 = '0';
      }
      if (!this.actEmt3Weight2) {
        this.actEmt3Weight2 = '0';
      }
      if (!this.actEmt4Weight1) {
        this.actEmt4Weight1 = '0';
      }
      if (!this.actEmt4Weight2) {
        this.actEmt4Weight2 = '0';
      }
      if (!this.actEmt5Weight1) {
        this.actEmt5Weight1 = '0';
      }
      if (!this.actEmt5Weight2) {
        this.actEmt5Weight2 = '0';
      }
      if (!this.actEmt6Weight1) {
        this.actEmt6Weight1 = '0';
      }
      if (!this.actEmt6Weight2) {
        this.actEmt6Weight2 = '0';
      }

      // 共通
      this.updateAt = moment().format('YYYYMMDDHHmmss');

      //----- 行動要素情報更新リクエストPOST
      axios
        .post(
          config.CONNECT_EVALUATIONS_URL +
            '/Evaluations/manages/goal/grade/action/update',
          {
            SESSION_ID: userInfo.SESSION_ID,
            SESSION_USER_ID: userInfo.USER_ID,
            GOAL_ID: this.goalId,
            GRADE_ID: this.gradeId,
            ACT_EMT_1_ID: this.actEmt1Id,
            ACT_EMT_1_NAME: this.actEmt1Name,
            ACT_EMT_1_CONTENT1: this.actEmt1Content1,
            ACT_EMT_1_CONTENT2: this.actEmt1Content2,
            ACT_EMT_1_WEIGHT1: this.actEmt1Weight1,
            ACT_EMT_1_WEIGHT2: this.actEmt1Weight2,

            ACT_EMT_2_ID: this.actEmt2Id,
            ACT_EMT_2_NAME: this.actEmt2Name,
            ACT_EMT_2_CONTENT1: this.actEmt2Content1,
            ACT_EMT_2_CONTENT2: this.actEmt2Content2,
            ACT_EMT_2_WEIGHT1: this.actEmt2Weight1,
            ACT_EMT_2_WEIGHT2: this.actEmt2Weight2,

            ACT_EMT_3_ID: this.actEmt3Id,
            ACT_EMT_3_NAME: this.actEmt3Name,
            ACT_EMT_3_CONTENT1: this.actEmt3Content1,
            ACT_EMT_3_CONTENT2: this.actEmt3Content2,
            ACT_EMT_3_WEIGHT1: this.actEmt3Weight1,
            ACT_EMT_3_WEIGHT2: this.actEmt3Weight2,

            ACT_EMT_4_ID: this.actEmt4Id,
            ACT_EMT_4_NAME: this.actEmt4Name,
            ACT_EMT_4_CONTENT1: this.actEmt4Content1,
            ACT_EMT_4_CONTENT2: this.actEmt4Content2,
            ACT_EMT_4_WEIGHT1: this.actEmt4Weight1,
            ACT_EMT_4_WEIGHT2: this.actEmt4Weight2,

            ACT_EMT_5_ID: this.actEmt5Id,
            ACT_EMT_5_NAME: this.actEmt5Name,
            ACT_EMT_5_CONTENT1: this.actEmt5Content1,
            ACT_EMT_5_CONTENT2: this.actEmt5Content2,
            ACT_EMT_5_WEIGHT1: this.actEmt5Weight1,
            ACT_EMT_5_WEIGHT2: this.actEmt5Weight2,

            ACT_EMT_6_ID: this.actEmt6Id,
            ACT_EMT_6_NAME: this.actEmt6Name,
            ACT_EMT_6_CONTENT1: this.actEmt6Content1,
            ACT_EMT_6_CONTENT2: this.actEmt6Content2,
            ACT_EMT_6_WEIGHT1: this.actEmt6Weight1,
            ACT_EMT_6_WEIGHT2: this.actEmt6Weight2,

            UPDATED_AT: this.updateAt,
          }
        )
        .then((response) => {
          // ローディング画像終了
          this.loading = false;

          let msgStr = '';
          if (response.status == 200) {
            msgStr =
              this.humanPowerTitle + message.MSG_INFO_GOAL_ENTRY_COMPLETE;
            this.$refs.dialog.open('info', msgStr);
            this.$emit('edit');
          }
        })
        .catch((error) => {
          // ローディング画像終了
          this.loading = false;

          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          }
        });

      this.resolve(true);
      this.dialog = false;
    },

    deleteEvaluationInfoRequest() {
      // ローディング画像表示
      this.loading = true;
      // ユーザ情報の取得
      let userInfo = getSessionStorageItem();
      // 共通
      this.updateAt = moment().format('YYYYMMDDHHmmss');

      //----- 行動要素情報更新リクエストPOST
      axios
        .post(
          config.CONNECT_EVALUATIONS_URL +
            '/Evaluations/manages/goal/grade/allaction/update',
          {
            SESSION_ID: userInfo.SESSION_ID,
            SESSION_USER_ID: userInfo.USER_ID,

            GOAL_ID: this.goalId,
            GRADE_ID: this.gradeId,
            ACT_EMT_1_ID: this.actEmt1Id,
            ACT_EMT_1_NAME: this.actEmt1Name,
            ACT_EMT_1_CONTENT1: this.actEmt1Content1,
            ACT_EMT_1_CONTENT2: this.actEmt1Content2,
            ACT_EMT_1_WEIGHT1: this.actEmt1Weight1,
            ACT_EMT_1_WEIGHT2: this.actEmt1Weight2,

            ACT_EMT_2_ID: this.actEmt2Id,
            ACT_EMT_2_NAME: this.actEmt2Name,
            ACT_EMT_2_CONTENT1: this.actEmt2Content1,
            ACT_EMT_2_CONTENT2: this.actEmt2Content2,
            ACT_EMT_2_WEIGHT1: this.actEmt2Weight1,
            ACT_EMT_2_WEIGHT2: this.actEmt2Weight2,

            ACT_EMT_3_ID: this.actEmt3Id,
            ACT_EMT_3_NAME: this.actEmt3Name,
            ACT_EMT_3_CONTENT1: this.actEmt3Content1,
            ACT_EMT_3_CONTENT2: this.actEmt3Content2,
            ACT_EMT_3_WEIGHT1: this.actEmt3Weight1,
            ACT_EMT_3_WEIGHT2: this.actEmt3Weight2,

            ACT_EMT_4_ID: this.actEmt4Id,
            ACT_EMT_4_NAME: this.actEmt4Name,
            ACT_EMT_4_CONTENT1: this.actEmt4Content1,
            ACT_EMT_4_CONTENT2: this.actEmt4Content2,
            ACT_EMT_4_WEIGHT1: this.actEmt4Weight1,
            ACT_EMT_4_WEIGHT2: this.actEmt4Weight2,

            ACT_EMT_5_ID: this.actEmt5Id,
            ACT_EMT_5_NAME: this.actEmt5Name,
            ACT_EMT_5_CONTENT1: this.actEmt5Content1,
            ACT_EMT_5_CONTENT2: this.actEmt5Content2,
            ACT_EMT_5_WEIGHT1: this.actEmt5Weight1,
            ACT_EMT_5_WEIGHT2: this.actEmt5Weight2,

            ACT_EMT_6_ID: this.actEmt6Id,
            ACT_EMT_6_NAME: this.actEmt6Name,
            ACT_EMT_6_CONTENT1: this.actEmt6Content1,
            ACT_EMT_6_CONTENT2: this.actEmt6Content2,
            ACT_EMT_6_WEIGHT1: this.actEmt6Weight1,
            ACT_EMT_6_WEIGHT2: this.actEmt6Weight2,

            UPDATED_AT: this.updateAt,
          }
        )
        .then((response) => {
          // ローディング画像終了
          this.loading = false;

          let msgStr = '';
          if (response.status == 200) {
            msgStr =
              this.humanPowerTitle + message.MSG_INFO_GOAL_DELETE_COMPLETE;
            this.$refs.dialog.open('info', msgStr);
            this.$emit('edit');
          }
        })
        .catch((error) => {
          // ローディング画像終了
          this.loading = false;

          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          }
        });

      this.resolve(true);
      this.dialog = false;
    },

    async getEvaluationItem() {
      this.loading = true;

      // ユーザ情報取得
      let userInfo = getSessionStorageItem();

      // セッションチェック
      if (userInfo == null) {
        this.$refs.dialog.open(
          'error',
          message.MSG_ERROR_SESSION + message.MSG_ERROR_SESSION_DETAIL
        );
        this.loading = false;
        return;
      }

      await axios
        .get(
          config.CONNECT_EVALUATIONS_URL +
            '/Evaluations/manages/goal/grade/' +
            userInfo.SESSION_ID +
            '/' +
            userInfo.USER_ID +
            '/' +
            this.goalId +
            '/' +
            this.gradeId
        )
        .then((response) => {
          // 評価データ取得
          this.actEmt1Id = response.data[0].ACT_EMT_1_ID;
          this.actEmt1Name = response.data[0].ACT_EMT_1_NAME;
          this.actEmt1Content1 = response.data[0].ACT_EMT_1_CONTENT1;
          this.actEmt1Content2 = response.data[0].ACT_EMT_1_CONTENT2;
          this.actEmt1Weight1 = response.data[0].ACT_EMT_1_WEIGHT1;
          this.actEmt1Weight2 = response.data[0].ACT_EMT_1_WEIGHT2;

          this.actEmt2Id = response.data[0].ACT_EMT_2_ID;
          this.actEmt2Name = response.data[0].ACT_EMT_2_NAME;
          this.actEmt2Content1 = response.data[0].ACT_EMT_2_CONTENT1;
          this.actEmt2Content2 = response.data[0].ACT_EMT_2_CONTENT2;
          this.actEmt2Weight1 = response.data[0].ACT_EMT_2_WEIGHT1;
          this.actEmt2Weight2 = response.data[0].ACT_EMT_2_WEIGHT2;

          this.actEmt3Id = response.data[0].ACT_EMT_3_ID;
          this.actEmt3Name = response.data[0].ACT_EMT_3_NAME;
          this.actEmt3Content1 = response.data[0].ACT_EMT_3_CONTENT1;
          this.actEmt3Content2 = response.data[0].ACT_EMT_3_CONTENT2;
          this.actEmt3Weight1 = response.data[0].ACT_EMT_3_WEIGHT1;
          this.actEmt3Weight2 = response.data[0].ACT_EMT_3_WEIGHT2;

          this.actEmt4Id = response.data[0].ACT_EMT_4_ID;
          this.actEmt4Name = response.data[0].ACT_EMT_4_NAME;
          this.actEmt4Content1 = response.data[0].ACT_EMT_4_CONTENT1;
          this.actEmt4Content2 = response.data[0].ACT_EMT_4_CONTENT2;
          this.actEmt4Weight1 = response.data[0].ACT_EMT_4_WEIGHT1;
          this.actEmt4Weight2 = response.data[0].ACT_EMT_4_WEIGHT2;

          this.actEmt5Id = response.data[0].ACT_EMT_5_ID;
          this.actEmt5Name = response.data[0].ACT_EMT_5_NAME;
          this.actEmt5Content1 = response.data[0].ACT_EMT_5_CONTENT1;
          this.actEmt5Content2 = response.data[0].ACT_EMT_5_CONTENT2;
          this.actEmt5Weight1 = response.data[0].ACT_EMT_5_WEIGHT1;
          this.actEmt5Weight2 = response.data[0].ACT_EMT_5_WEIGHT2;

          this.actEmt6Id = response.data[0].ACT_EMT_6_ID;
          this.actEmt6Name = response.data[0].ACT_EMT_6_NAME;
          this.actEmt6Content1 = response.data[0].ACT_EMT_6_CONTENT1;
          this.actEmt6Content2 = response.data[0].ACT_EMT_6_CONTENT2;
          this.actEmt6Weight1 = response.data[0].ACT_EMT_6_WEIGHT1;
          this.actEmt6Weight2 = response.data[0].ACT_EMT_6_WEIGHT2;
        })
        .catch((error) => {
          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
          }
        });

      this.loading = false;
    },
    async getActionElement() {
      this.loading = true;

      // ユーザ情報取得
      let userInfo = getSessionStorageItem();

      // セッションチェック
      if (userInfo == null) {
        this.$refs.dialog.open(
          'error',
          message.MSG_ERROR_SESSION + message.MSG_ERROR_SESSION_DETAIL
        );
        this.loading = false;
        return;
      }

      let vm = this;

      await axios
        .get(
          config.CONNECT_EVALUATIONS_URL +
            '/Evaluations/manages/action/' +
            userInfo.SESSION_ID +
            '/' +
            userInfo.USER_ID +
            '/' +
            userInfo.ORGANIZATION_KEY
        )
        .then((response) => {
          // 行動要素データ取得
          vm.items = response.data;
          for (let i = 0; i < vm.items.length; i++) {
            var item = {
              label: vm.items[i].ACT_EMT_NAME,
              value: vm.items[i].ACT_EMT_ID,
            };
            this.actionElements.push(item);
          }
          // 目標等級情報取得
          this.getEvaluationItem();
        })
        .catch((error) => {
          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
          }
        });
      // ローディング画像終了
      this.loading = false;
    },
    makeUpdateGoalInfo() {
      if (this.groupId == this.groupSelect.value) {
        // 表示順が変更になっていない場合
        if (this.groupId == 1) {
          // 表示順1
          this.actEmt1Id = this.actionElement.value;
          this.actEmt1Name = this.actionElement.label;
          this.actEmt1Content1 = this.actEmtContent1;
          this.actEmt1Content2 = this.actEmtContent2;
          this.actEmt1Weight1 = this.actEmtWeight1;
          this.actEmt1Weight2 = this.actEmtWeight2;
        } else if (this.groupId == 2) {
          // 表示順2
          this.actEmt2Id = this.actionElement.value;
          this.actEmt2Name = this.actionElement.label;
          this.actEmt2Content1 = this.actEmtContent1;
          this.actEmt2Content2 = this.actEmtContent2;
          this.actEmt2Weight1 = this.actEmtWeight1;
          this.actEmt2Weight2 = this.actEmtWeight2;
        } else if (this.groupId == 3) {
          // 表示順3
          this.actEmt3Id = this.actionElement.value;
          this.actEmt3Name = this.actionElement.label;
          this.actEmt3Content1 = this.actEmtContent1;
          this.actEmt3Content2 = this.actEmtContent2;
          this.actEmt3Weight1 = this.actEmtWeight1;
          this.actEmt3Weight2 = this.actEmtWeight2;
        } else if (this.groupId == 4) {
          // 表示順4
          this.actEmt4Id = this.actionElement.value;
          this.actEmt4Name = this.actionElement.label;
          this.actEmt4Content1 = this.actEmtContent1;
          this.actEmt4Content2 = this.actEmtContent2;
          this.actEmt4Weight1 = this.actEmtWeight1;
          this.actEmt4Weight2 = this.actEmtWeight2;
        } else if (this.groupId == 5) {
          // 表示順5
          this.actEmt5Id = this.actionElement.value;
          this.actEmt5Name = this.actionElement.label;
          this.actEmt5Content1 = this.actEmtContent1;
          this.actEmt5Content2 = this.actEmtContent2;
          this.actEmt5Weight1 = this.actEmtWeight1;
          this.actEmt5Weight2 = this.actEmtWeight2;
        } else if (this.groupId == 6) {
          // 表示順6
          this.actEmt6Id = this.actionElement.value;
          this.actEmt6Name = this.actionElement.label;
          this.actEmt6Content1 = this.actEmtContent1;
          this.actEmt6Content2 = this.actEmtContent2;
          this.actEmt6Weight1 = this.actEmtWeight1;
          this.actEmt6Weight2 = this.actEmtWeight2;
        }
      } else {
        // 表示順が変更になった場合
        var tmpActEmtId = '';
        var tmpActEmtName = '';
        var tmpActEmtContent1 = '';
        var tmpActEmtContent2 = '';
        var tmpActEmtWeight1 = 0;
        var tmpActEmtWeight2 = 0;

        //----- 更新前の値を退避して、更新
        if (this.groupSelect.value == 1) {
          // 表示順1
          tmpActEmtId = this.actEmt1Id;
          tmpActEmtName = this.actEmt1Name;
          tmpActEmtContent1 = this.actEmt1Content1;
          tmpActEmtContent2 = this.actEmt1Content2;
          tmpActEmtWeight1 = this.actEmt1Weight1;
          tmpActEmtWeight2 = this.actEmt1Weight2;
          this.actEmt1Id = this.actionElement.value;
          this.actEmt1Name = this.actionElement.label;
          this.actEmt1Content1 = this.actEmtContent1;
          this.actEmt1Content2 = this.actEmtContent2;
          this.actEmt1Weight1 = this.actEmtWeight1;
          this.actEmt1Weight2 = this.actEmtWeight2;
        } else if (this.groupSelect.value == 2) {
          // 表示順2
          tmpActEmtId = this.actEmt2Id;
          tmpActEmtName = this.actEmt2Name;
          tmpActEmtContent1 = this.actEmt2Content1;
          tmpActEmtContent2 = this.actEmt2Content2;
          tmpActEmtWeight1 = this.actEmt2Weight1;
          tmpActEmtWeight2 = this.actEmt2Weight2;
          this.actEmt2Id = this.actionElement.value;
          this.actEmt2Name = this.actionElement.label;
          this.actEmt2Content1 = this.actEmtContent1;
          this.actEmt2Content2 = this.actEmtContent2;
          this.actEmt2Weight1 = this.actEmtWeight1;
          this.actEmt2Weight2 = this.actEmtWeight2;
        } else if (this.groupSelect.value == 3) {
          // 表示順3
          tmpActEmtId = this.actEmt3Id;
          tmpActEmtName = this.actEmt3Name;
          tmpActEmtContent1 = this.actEmt3Content1;
          tmpActEmtContent2 = this.actEmt3Content2;
          tmpActEmtWeight1 = this.actEmt3Weight1;
          tmpActEmtWeight2 = this.actEmt3Weight2;
          this.actEmt3Id = this.actionElement.value;
          this.actEmt3Name = this.actionElement.label;
          this.actEmt3Content1 = this.actEmtContent1;
          this.actEmt3Content2 = this.actEmtContent2;
          this.actEmt3Weight1 = this.actEmtWeight1;
          this.actEmt3Weight2 = this.actEmtWeight2;
        } else if (this.groupSelect.value == 4) {
          // 表示順4
          tmpActEmtId = this.actEmt4Id;
          tmpActEmtName = this.actEmt4Name;
          tmpActEmtContent1 = this.actEmt4Content1;
          tmpActEmtContent2 = this.actEmt4Content2;
          tmpActEmtWeight1 = this.actEmt4Weight1;
          tmpActEmtWeight2 = this.actEmt4Weight2;
          this.actEmt4Id = this.actionElement.value;
          this.actEmt4Name = this.actionElement.label;
          this.actEmt4Content1 = this.actEmtContent1;
          this.actEmt4Content2 = this.actEmtContent2;
          this.actEmt4Weight1 = this.actEmtWeight1;
          this.actEmt4Weight2 = this.actEmtWeight2;
        } else if (this.groupSelect.value == 5) {
          // 表示順5
          tmpActEmtId = this.actEmt5Id;
          tmpActEmtName = this.actEmt5Name;
          tmpActEmtContent1 = this.actEmt5Content1;
          tmpActEmtContent2 = this.actEmt5Content2;
          tmpActEmtWeight1 = this.actEmt5Weight1;
          tmpActEmtWeight2 = this.actEmt5Weight2;
          this.actEmt5Id = this.actionElement.value;
          this.actEmt5Name = this.actionElement.label;
          this.actEmt5Content1 = this.actEmtContent1;
          this.actEmt5Content2 = this.actEmtContent2;
          this.actEmt5Weight1 = this.actEmtWeight1;
          this.actEmt5Weight2 = this.actEmtWeight2;
        } else if (this.groupSelect.value == 6) {
          // 表示順6
          tmpActEmtId = this.actEmt6Id;
          tmpActEmtName = this.actEmt6Name;
          tmpActEmtContent1 = this.actEmt6Content1;
          tmpActEmtContent2 = this.actEmt6Content2;
          tmpActEmtWeight1 = this.actEmt6Weight1;
          tmpActEmtWeight2 = this.actEmt6Weight2;
          this.actEmt6Id = this.actionElement.value;
          this.actEmt6Name = this.actionElement.label;
          this.actEmt6Content1 = this.actEmtContent1;
          this.actEmt6Content2 = this.actEmtContent2;
          this.actEmt6Weight1 = this.actEmtWeight1;
          this.actEmt6Weight2 = this.actEmtWeight2;
        }

        //----- 更新前の値を入れ替え
        if (this.groupId == 1) {
          // 表示順1
          this.actEmt1Id = tmpActEmtId;
          this.actEmt1Name = tmpActEmtName;
          this.actEmt1Content1 = tmpActEmtContent1;
          this.actEmt1Content2 = tmpActEmtContent2;
          this.actEmt1Weight1 = tmpActEmtWeight1;
          this.actEmt1Weight2 = tmpActEmtWeight2;
        } else if (this.groupId == 2) {
          // 表示順2
          this.actEmt2Id = tmpActEmtId;
          this.actEmt2Name = tmpActEmtName;
          this.actEmt2Content1 = tmpActEmtContent1;
          this.actEmt2Content2 = tmpActEmtContent2;
          this.actEmt2Weight1 = tmpActEmtWeight1;
          this.actEmt2Weight2 = tmpActEmtWeight2;
        } else if (this.groupId == 3) {
          // 表示順3
          this.actEmt3Id = tmpActEmtId;
          this.actEmt3Name = tmpActEmtName;
          this.actEmt3Content1 = tmpActEmtContent1;
          this.actEmt3Content2 = tmpActEmtContent2;
          this.actEmt3Weight1 = tmpActEmtWeight1;
          this.actEmt3Weight2 = tmpActEmtWeight2;
        } else if (this.groupId == 4) {
          // 表示順4
          this.actEmt4Id = tmpActEmtId;
          this.actEmt4Name = tmpActEmtName;
          this.actEmt4Content1 = tmpActEmtContent1;
          this.actEmt4Content2 = tmpActEmtContent2;
          this.actEmt4Weight1 = tmpActEmtWeight1;
          this.actEmt4Weight2 = tmpActEmtWeight2;
        } else if (this.groupId == 5) {
          // 表示順5
          this.actEmt5Id = tmpActEmtId;
          this.actEmt5Name = tmpActEmtName;
          this.actEmt5Content1 = tmpActEmtContent1;
          this.actEmt5Content2 = tmpActEmtContent2;
          this.actEmt5Weight1 = tmpActEmtWeight1;
          this.actEmt5Weight2 = tmpActEmtWeight2;
        } else if (this.groupId == 6) {
          // 表示順6
          this.actEmt6Id = tmpActEmtId;
          this.actEmt6Name = tmpActEmtName;
          this.actEmt6Content1 = tmpActEmtContent1;
          this.actEmt6Content2 = tmpActEmtContent2;
          this.actEmt6Weight1 = tmpActEmtWeight1;
          this.actEmt6Weight2 = tmpActEmtWeight2;
        }
      }
    },
    makeInsertGoalInfo() {
      // 表示順が変更になった場合
      var tmpActEmt1Id = this.actEmt1Id;
      var tmpActEmt1Name = this.actEmt1Name;
      var tmpActEmt1Content1 = this.actEmt1Content1;
      var tmpActEmt1Content2 = this.actEmt1Content2;
      var tmpActEmt1Weight1 = this.actEmt1Weight1;
      var tmpActEmt1Weight2 = this.actEmt1Weight2;

      var tmpActEmt2Id = this.actEmt2Id;
      var tmpActEmt2Name = this.actEmt2Name;
      var tmpActEmt2Content1 = this.actEmt2Content1;
      var tmpActEmt2Content2 = this.actEmt2Content2;
      var tmpActEmt2Weight1 = this.actEmt2Weight1;
      var tmpActEmt2Weight2 = this.actEmt2Weight2;

      var tmpActEmt3Id = this.actEmt3Id;
      var tmpActEmt3Name = this.actEmt3Name;
      var tmpActEmt3Content1 = this.actEmt3Content1;
      var tmpActEmt3Content2 = this.actEmt3Content2;
      var tmpActEmt3Weight1 = this.actEmt3Weight1;
      var tmpActEmt3Weight2 = this.actEmt3Weight2;

      var tmpActEmt4Id = this.actEmt4Id;
      var tmpActEmt4Name = this.actEmt4Name;
      var tmpActEmt4Content1 = this.actEmt4Content1;
      var tmpActEmt4Content2 = this.actEmt4Content2;
      var tmpActEmt4Weight1 = this.actEmt4Weight1;
      var tmpActEmt4Weight2 = this.actEmt4Weight2;

      var tmpActEmt5Id = this.actEmt5Id;
      var tmpActEmt5Name = this.actEmt5Name;
      var tmpActEmt5Content1 = this.actEmt5Content1;
      var tmpActEmt5Content2 = this.actEmt5Content2;
      var tmpActEmt5Weight1 = this.actEmt5Weight1;
      var tmpActEmt5Weight2 = this.actEmt5Weight2;

      var tmpActEmt6Id = this.actEmt6Id;
      var tmpActEmt6Name = this.actEmt6Name;
      var tmpActEmt6Content1 = this.actEmt6Content1;
      var tmpActEmt6Content2 = this.actEmt6Content2;
      var tmpActEmt6Weight1 = this.actEmt6Weight1;
      var tmpActEmt6Weight2 = this.actEmt6Weight2;

      if (this.groupSelect.value == 1) {
        // 表示順1
        this.actEmt1Id = this.actionElement.value;
        this.actEmt1Name = this.actionElement.label;
        this.actEmt1Content1 = this.actEmtContent1;
        this.actEmt1Content2 = this.actEmtContent2;
        this.actEmt1Weight1 = this.actEmtWeight1;
        this.actEmt1Weight2 = this.actEmtWeight2;

        // 入れ替え
        if (tmpActEmt1Id != config.GOAL_EMPTY_STRING) {
          // 表示順1 入力済みの場合、入れ替え
          this.actEmt2Id = tmpActEmt1Id;
          this.actEmt2Name = tmpActEmt1Name;
          this.actEmt2Content1 = tmpActEmt1Content1;
          this.actEmt2Content2 = tmpActEmt1Content2;
          this.actEmt2Weight1 = tmpActEmt1Weight1;
          this.actEmt2Weight2 = tmpActEmt1Weight2;

          if (tmpActEmt2Id != config.GOAL_EMPTY_STRING) {
            // 表示順2 入力済みの場合、入れ替え
            this.actEmt3Id = tmpActEmt2Id;
            this.actEmt3Name = tmpActEmt2Name;
            this.actEmt3Content1 = tmpActEmt2Content1;
            this.actEmt3Content2 = tmpActEmt2Content2;
            this.actEmt3Weight1 = tmpActEmt2Weight1;
            this.actEmt3Weight2 = tmpActEmt2Weight2;

            if (tmpActEmt3Id != config.GOAL_EMPTY_STRING) {
              // 表示順3 入力済みの場合、入れ替え
              this.actEmt4Id = tmpActEmt3Id;
              this.actEmt4Name = tmpActEmt3Name;
              this.actEmt4Content1 = tmpActEmt3Content1;
              this.actEmt4Content2 = tmpActEmt3Content2;
              this.actEmt4Weight1 = tmpActEmt3Weight1;
              this.actEmt4Weight2 = tmpActEmt3Weight2;

              if (tmpActEmt4Id != config.GOAL_EMPTY_STRING) {
                // 表示順4 入力済みの場合、入れ替え
                this.actEmt5Id = tmpActEmt4Id;
                this.actEmt5Name = tmpActEmt4Name;
                this.actEmt5Content1 = tmpActEmt4Content1;
                this.actEmt5Content2 = tmpActEmt4Content2;
                this.actEmt5Weight1 = tmpActEmt4Weight1;
                this.actEmt5Weight2 = tmpActEmt4Weight2;

                if (tmpActEmt5Id != config.GOAL_EMPTY_STRING) {
                  // 表示順5 入力済みの場合、入れ替え
                  this.actEmt6Id = tmpActEmt5Id;
                  this.actEmt6Name = tmpActEmt5Name;
                  this.actEmt6Content1 = tmpActEmt5Content1;
                  this.actEmt6Content2 = tmpActEmt5Content2;
                  this.actEmt6Weight1 = tmpActEmt5Weight1;
                  this.actEmt6Weight2 = tmpActEmt5Weight2;
                }
              }
            }
          }
        }
      } else if (this.groupSelect.value == 2) {
        // 表示順2
        this.actEmt2Id = this.actionElement.value;
        this.actEmt2Name = this.actionElement.label;
        this.actEmt2Content1 = this.actEmtContent1;
        this.actEmt2Content2 = this.actEmtContent2;
        this.actEmt2Weight1 = this.actEmtWeight1;
        this.actEmt2Weight2 = this.actEmtWeight2;

        // 入れ替え
        if (tmpActEmt2Id != config.GOAL_EMPTY_STRING) {
          // 表示順2 入力済みの場合、入れ替え
          this.actEmt3Id = tmpActEmt2Id;
          this.actEmt3Name = tmpActEmt2Name;
          this.actEmt3Content1 = tmpActEmt2Content1;
          this.actEmt3Content2 = tmpActEmt2Content2;
          this.actEmt3Weight1 = tmpActEmt2Weight1;
          this.actEmt3Weight2 = tmpActEmt2Weight2;

          if (tmpActEmt3Id != config.GOAL_EMPTY_STRING) {
            // 表示順3 入力済みの場合、入れ替え
            this.actEmt4Id = tmpActEmt3Id;
            this.actEmt4Name = tmpActEmt3Name;
            this.actEmt4Content1 = tmpActEmt3Content1;
            this.actEmt4Content2 = tmpActEmt3Content2;
            this.actEmt4Weight1 = tmpActEmt3Weight1;
            this.actEmt4Weight2 = tmpActEmt3Weight2;

            if (tmpActEmt4Id != config.GOAL_EMPTY_STRING) {
              // 表示順4 入力済みの場合、入れ替え
              this.actEmt5Id = tmpActEmt4Id;
              this.actEmt5Name = tmpActEmt4Name;
              this.actEmt5Content1 = tmpActEmt4Content1;
              this.actEmt5Content2 = tmpActEmt4Content2;
              this.actEmt5Weight1 = tmpActEmt4Weight1;
              this.actEmt5Weight2 = tmpActEmt4Weight2;

              if (tmpActEmt5Id != config.GOAL_EMPTY_STRING) {
                // 表示順5 入力済みの場合、入れ替え
                this.actEmt6Id = tmpActEmt5Id;
                this.actEmt6Name = tmpActEmt5Name;
                this.actEmt6Content1 = tmpActEmt5Content1;
                this.actEmt6Content2 = tmpActEmt5Content2;
                this.actEmt6Weight1 = tmpActEmt5Weight1;
                this.actEmt6Weight2 = tmpActEmt5Weight2;
              }
            }
          }
        }
      } else if (this.groupSelect.value == 3) {
        // 表示順3
        this.actEmt3Id = this.actionElement.value;
        this.actEmt3Name = this.actionElement.label;
        this.actEmt3Content1 = this.actEmtContent1;
        this.actEmt3Content2 = this.actEmtContent2;
        this.actEmt3Weight1 = this.actEmtWeight1;
        this.actEmt3Weight2 = this.actEmtWeight2;

        // 入れ替え
        if (tmpActEmt3Id != config.GOAL_EMPTY_STRING) {
          // 表示順3 入力済みの場合、入れ替え
          this.actEmt4Id = tmpActEmt3Id;
          this.actEmt4Name = tmpActEmt3Name;
          this.actEmt4Content1 = tmpActEmt3Content1;
          this.actEmt4Content2 = tmpActEmt3Content2;
          this.actEmt4Weight1 = tmpActEmt3Weight1;
          this.actEmt4Weight2 = tmpActEmt3Weight2;

          if (tmpActEmt4Id != config.GOAL_EMPTY_STRING) {
            // 表示順4 入力済みの場合、入れ替え
            this.actEmt5Id = tmpActEmt4Id;
            this.actEmt5Name = tmpActEmt4Name;
            this.actEmt5Content1 = tmpActEmt4Content1;
            this.actEmt5Content2 = tmpActEmt4Content2;
            this.actEmt5Weight1 = tmpActEmt4Weight1;
            this.actEmt5Weight2 = tmpActEmt4Weight2;

            if (tmpActEmt5Id != config.GOAL_EMPTY_STRING) {
              // 表示順5 入力済みの場合、入れ替え
              this.actEmt6Id = tmpActEmt5Id;
              this.actEmt6Name = tmpActEmt5Name;
              this.actEmt6Content1 = tmpActEmt5Content1;
              this.actEmt6Content2 = tmpActEmt5Content2;
              this.actEmt6Weight1 = tmpActEmt5Weight1;
              this.actEmt6Weight2 = tmpActEmt5Weight2;
            }
          }
        }
      } else if (this.groupSelect.value == 4) {
        // 表示順4
        this.actEmt4Id = this.actionElement.value;
        this.actEmt4Name = this.actionElement.label;
        this.actEmt4Content1 = this.actEmtContent1;
        this.actEmt4Content2 = this.actEmtContent2;
        this.actEmt4Weight1 = this.actEmtWeight1;
        this.actEmt4Weight2 = this.actEmtWeight2;

        // 入れ替え
        if (tmpActEmt4Id != config.GOAL_EMPTY_STRING) {
          // 表示順4 入力済みの場合、入れ替え
          this.actEmt5Id = tmpActEmt4Id;
          this.actEmt5Name = tmpActEmt4Name;
          this.actEmt5Content1 = tmpActEmt4Content1;
          this.actEmt5Content2 = tmpActEmt4Content2;
          this.actEmt5Weight1 = tmpActEmt4Weight1;
          this.actEmt5Weight2 = tmpActEmt4Weight2;

          if (tmpActEmt5Id != config.GOAL_EMPTY_STRING) {
            // 表示順5 入力済みの場合、入れ替え
            this.actEmt6Id = tmpActEmt5Id;
            this.actEmt6Name = tmpActEmt5Name;
            this.actEmt6Content1 = tmpActEmt5Content1;
            this.actEmt6Content2 = tmpActEmt5Content2;
            this.actEmt6Weight1 = tmpActEmt5Weight1;
            this.actEmt6Weight2 = tmpActEmt5Weight2;
          }
        }
      } else if (this.groupSelect.value == 5) {
        // 表示順5
        this.actEmt5Id = this.actionElement.value;
        this.actEmt5Name = this.actionElement.label;
        this.actEmt5Content1 = this.actEmtContent1;
        this.actEmt5Content2 = this.actEmtContent2;
        this.actEmt5Weight1 = this.actEmtWeight1;
        this.actEmt5Weight2 = this.actEmtWeight2;

        // 入れ替え
        if (tmpActEmt5Id != config.GOAL_EMPTY_STRING) {
          // 表示順5 入力済みの場合、入れ替え
          this.actEmt6Id = tmpActEmt5Id;
          this.actEmt6Name = tmpActEmt5Name;
          this.actEmt6Content1 = tmpActEmt5Content1;
          this.actEmt6Content2 = tmpActEmt5Content2;
          this.actEmt6Weight1 = tmpActEmt5Weight1;
          this.actEmt6Weight2 = tmpActEmt5Weight2;
        }
      } else if (this.groupSelect.value == 6) {
        // 表示順6
        this.actEmt6Id = this.actionElement.value;
        this.actEmt6Name = this.actionElement.label;
        this.actEmt6Content1 = this.actEmtContent1;
        this.actEmt6Content2 = this.actEmtContent2;
        this.actEmt6Weight1 = this.actEmtWeight1;
        this.actEmt6Weight2 = this.actEmtWeight2;

        // 入れ替え
        if (tmpActEmt6Id != config.GOAL_EMPTY_STRING) {
          // 表示順6 入力済みの場合、入れ替え
          this.actEmt5Id = tmpActEmt6Id;
          this.actEmt5Name = tmpActEmt6Name;
          this.actEmt5Content1 = tmpActEmt6Content1;
          this.actEmt5Content2 = tmpActEmt6Content2;
          this.actEmt5Weight1 = tmpActEmt6Weight1;
          this.actEmt5Weight2 = tmpActEmt6Weight2;

          if (tmpActEmt5Id != config.GOAL_EMPTY_STRING) {
            // 表示順5 入力済みの場合、入れ替え
            this.actEmt4Id = tmpActEmt5Id;
            this.actEmt4Name = tmpActEmt5Name;
            this.actEmt4Content1 = tmpActEmt5Content1;
            this.actEmt4Content2 = tmpActEmt5Content2;
            this.actEmt4Weight1 = tmpActEmt5Weight1;
            this.actEmt4Weight2 = tmpActEmt5Weight2;

            if (tmpActEmt4Id != config.GOAL_EMPTY_STRING) {
              // 表示順4 入力済みの場合、入れ替え
              this.actEmt3Id = tmpActEmt4Id;
              this.actEmt3Name = tmpActEmt4Name;
              this.actEmt3Content1 = tmpActEmt4Content1;
              this.actEmt3Content2 = tmpActEmt4Content2;
              this.actEmt3Weight1 = tmpActEmt4Weight1;
              this.actEmt3Weight2 = tmpActEmt4Weight2;

              if (tmpActEmt3Id != config.GOAL_EMPTY_STRING) {
                // 表示順3 入力済みの場合、入れ替え
                this.actEmt2Id = tmpActEmt3Id;
                this.actEmt2Name = tmpActEmt3Name;
                this.actEmt2Content1 = tmpActEmt3Content1;
                this.actEmt2Content2 = tmpActEmt3Content2;
                this.actEmt2Weight1 = tmpActEmt3Weight1;
                this.actEmt2Weight2 = tmpActEmt3Weight2;

                if (tmpActEmt2Id != config.GOAL_EMPTY_STRING) {
                  // 表示順2 入力済みの場合、入れ替え
                  this.actEmt1Id = tmpActEmt2Id;
                  this.actEmt1Name = tmpActEmt2Name;
                  this.actEmt1Content1 = tmpActEmt2Content1;
                  this.actEmt1Content2 = tmpActEmt2Content2;
                  this.actEmt1Weight1 = tmpActEmt2Weight1;
                  this.actEmt1Weight2 = tmpActEmt2Weight2;
                }
              }
            }
          }
        }
      }
    },
    makeDeleteGoalContent2() {
      // 行動内容の削除を行うデータを作成
      if (this.groupId == 1) {
        // 行動要素1 行動内容2の削除
        this.actEmt1Content2 = config.GOAL_EMPTY_STRING;
        this.actEmt1Weight2 = 0;
      } else if (this.groupId == 2) {
        // 行動要素2 行動内容2の削除
        this.actEmt2Content2 = config.GOAL_EMPTY_STRING;
        this.actEmt2Weight2 = 0;
      } else if (this.groupId == 3) {
        // 行動要素3 行動内容2の削除
        this.actEmt3Content2 = config.GOAL_EMPTY_STRING;
        this.actEmt3Weight2 = 0;
      } else if (this.groupId == 4) {
        // 行動要素4 行動内容2の削除
        this.actEmt4Content2 = config.GOAL_EMPTY_STRING;
        this.actEmt4Weight2 = 0;
      } else if (this.groupId == 5) {
        // 行動要素5 行動内容2の削除
        this.actEmt5Content2 = config.GOAL_EMPTY_STRING;
        this.actEmt5Weight2 = 0;
      } else if (this.groupId == 6) {
        // 行動要素6 行動内容2の削除
        this.actEmt6Content2 = config.GOAL_EMPTY_STRING;
        this.actEmt6Weight2 = 0;
      }
    },
    makeDeleteEvaluationInfo() {
      // 行動内容の削除を行うデータを作成
      if (this.groupId == 1) {
        // 行動内容1の削除
        this.actEmt1Id = this.actEmt2Id;
        this.actEmt1Name = this.actEmt2Name;
        this.actEmt1Content1 = this.actEmt2Content1;
        this.actEmt1Content2 = this.actEmt2Content2;
        this.actEmt1Weight1 = this.actEmt2Weight1;
        this.actEmt1Weight2 = this.actEmt2Weight2;

        this.actEmt2Id = this.actEmt3Id;
        this.actEmt2Name = this.actEmt3Name;
        this.actEmt2Content1 = this.actEmt3Content1;
        this.actEmt2Content2 = this.actEmt3Content2;
        this.actEmt2Weight1 = this.actEmt3Weight1;
        this.actEmt2Weight2 = this.actEmt3Weight2;

        this.actEmt3Id = this.actEmt4Id;
        this.actEmt3Name = this.actEmt4Name;
        this.actEmt3Content1 = this.actEmt4Content1;
        this.actEmt3Content2 = this.actEmt4Content2;
        this.actEmt3Weight1 = this.actEmt4Weight1;
        this.actEmt3Weight2 = this.actEmt4Weight2;

        this.actEmt4Id = this.actEmt5Id;
        this.actEmt4Name = this.actEmt5Name;
        this.actEmt4Content1 = this.actEmt5Content1;
        this.actEmt4Content2 = this.actEmt5Content2;
        this.actEmt4Weight1 = this.actEmt5Weight1;
        this.actEmt4Weight2 = this.actEmt5Weight2;

        this.actEmt5Id = this.actEmt6Id;
        this.actEmt5Name = this.actEmt6Name;
        this.actEmt5Content1 = this.actEmt6Content1;
        this.actEmt5Content2 = this.actEmt6Content2;
        this.actEmt5Weight1 = this.actEmt6Weight1;
        this.actEmt5Weight2 = this.actEmt6Weight2;

        this.actEmt6Id = config.GOAL_EMPTY_STRING;
        this.actEmt6Name = config.GOAL_EMPTY_STRING;
        this.actEmt6Content1 = config.GOAL_EMPTY_STRING;
        this.actEmt6Content2 = config.GOAL_EMPTY_STRING;
        this.actEmt6Weight1 = 0;
        this.actEmt6Weight2 = 0;
      } else if (this.groupId == 2) {
        // 行動内容2の削除
        this.actEmt2Id = this.actEmt3Id;
        this.actEmt2Name = this.actEmt3Name;
        this.actEmt2Content1 = this.actEmt3Content1;
        this.actEmt2Content2 = this.actEmt3Content2;
        this.actEmt2Weight1 = this.actEmt3Weight1;
        this.actEmt2Weight2 = this.actEmt3Weight2;

        this.actEmt3Id = this.actEmt4Id;
        this.actEmt3Name = this.actEmt4Name;
        this.actEmt3Content1 = this.actEmt4Content1;
        this.actEmt3Content2 = this.actEmt4Content2;
        this.actEmt3Weight1 = this.actEmt4Weight1;
        this.actEmt3Weight2 = this.actEmt4Weight2;

        this.actEmt4Id = this.actEmt5Id;
        this.actEmt4Name = this.actEmt5Name;
        this.actEmt4Content1 = this.actEmt5Content1;
        this.actEmt4Content2 = this.actEmt5Content2;
        this.actEmt4Weight1 = this.actEmt5Weight1;
        this.actEmt4Weight2 = this.actEmt5Weight2;

        this.actEmt5Id = this.actEmt6Id;
        this.actEmt5Name = this.actEmt6Name;
        this.actEmt5Content1 = this.actEmt6Content1;
        this.actEmt5Content2 = this.actEmt6Content2;
        this.actEmt5Weight1 = this.actEmt6Weight1;
        this.actEmt5Weight2 = this.actEmt6Weight2;

        this.actEmt6Id = config.GOAL_EMPTY_STRING;
        this.actEmt6Name = config.GOAL_EMPTY_STRING;
        this.actEmt6Content1 = config.GOAL_EMPTY_STRING;
        this.actEmt6Content2 = config.GOAL_EMPTY_STRING;
        this.actEmt6Weight1 = 0;
        this.actEmt6Weight2 = 0;
      } else if (this.groupId == 3) {
        // 行動内容3の削除
        this.actEmt3Id = this.actEmt4Id;
        this.actEmt3Name = this.actEmt4Name;
        this.actEmt3Content1 = this.actEmt4Content1;
        this.actEmt3Content2 = this.actEmt4Content2;
        this.actEmt3Weight1 = this.actEmt4Weight1;
        this.actEmt3Weight2 = this.actEmt4Weight2;

        this.actEmt4Id = this.actEmt5Id;
        this.actEmt4Name = this.actEmt5Name;
        this.actEmt4Content1 = this.actEmt5Content1;
        this.actEmt4Content2 = this.actEmt5Content2;
        this.actEmt4Weight1 = this.actEmt5Weight1;
        this.actEmt4Weight2 = this.actEmt5Weight2;

        this.actEmt5Id = this.actEmt6Id;
        this.actEmt5Name = this.actEmt6Name;
        this.actEmt5Content1 = this.actEmt6Content1;
        this.actEmt5Content2 = this.actEmt6Content2;
        this.actEmt5Weight1 = this.actEmt6Weight1;
        this.actEmt5Weight2 = this.actEmt6Weight2;

        this.actEmt6Id = config.GOAL_EMPTY_STRING;
        this.actEmt6Name = config.GOAL_EMPTY_STRING;
        this.actEmt6Content1 = config.GOAL_EMPTY_STRING;
        this.actEmt6Content2 = config.GOAL_EMPTY_STRING;
        this.actEmt6Weight1 = 0;
        this.actEmt6Weight2 = 0;
      } else if (this.groupId == 4) {
        // 行動内容4の削除
        this.actEmt4Id = this.actEmt5Id;
        this.actEmt4Name = this.actEmt5Name;
        this.actEmt4Content1 = this.actEmt5Content1;
        this.actEmt4Content2 = this.actEmt5Content2;
        this.actEmt4Weight1 = this.actEmt5Weight1;
        this.actEmt4Weight2 = this.actEmt5Weight2;

        this.actEmt5Id = this.actEmt6Id;
        this.actEmt5Name = this.actEmt6Name;
        this.actEmt5Content1 = this.actEmt6Content1;
        this.actEmt5Content2 = this.actEmt6Content2;
        this.actEmt5Weight1 = this.actEmt6Weight1;
        this.actEmt5Weight2 = this.actEmt6Weight2;

        this.actEmt6Id = config.GOAL_EMPTY_STRING;
        this.actEmt6Name = config.GOAL_EMPTY_STRING;
        this.actEmt6Content1 = config.GOAL_EMPTY_STRING;
        this.actEmt6Content2 = config.GOAL_EMPTY_STRING;
        this.actEmt6Weight1 = 0;
        this.actEmt6Weight2 = 0;
      } else if (this.groupId == 5) {
        // 行動内容5の削除
        this.actEmt5Id = this.actEmt6Id;
        this.actEmt5Name = this.actEmt6Name;
        this.actEmt5Content1 = this.actEmt6Content1;
        this.actEmt5Content2 = this.actEmt6Content2;
        this.actEmt5Weight1 = this.actEmt6Weight1;
        this.actEmt5Weight2 = this.actEmt6Weight2;

        this.actEmt6Id = config.GOAL_EMPTY_STRING;
        this.actEmt6Name = config.GOAL_EMPTY_STRING;
        this.actEmt6Content1 = config.GOAL_EMPTY_STRING;
        this.actEmt6Content2 = config.GOAL_EMPTY_STRING;
        this.actEmt6Weight1 = 0;
        this.actEmt6Weight2 = 0;
      } else if (this.groupId == 6) {
        // 行動内容6の削除
        this.actEmt6Id = config.GOAL_EMPTY_STRING;
        this.actEmt6Name = config.GOAL_EMPTY_STRING;
        this.actEmt6Content1 = config.GOAL_EMPTY_STRING;
        this.actEmt6Content2 = config.GOAL_EMPTY_STRING;
        this.actEmt6Weight1 = 0;
        this.actEmt6Weight2 = 0;
      }
    },
    async regist() {
      this.dialog = false;
    },
    cancel() {
      this.dialog = false;
    },
  },
};
</script>
<style>
.ql-container {
  background-color: white;
  font-size: 16px;
}
.ql-toolbar {
  display: block;
  background-color: #f5f5f5;
}
</style>
